<script>
	import { createEventDispatcher } from "svelte";
	import { afterUpdate, onDestroy, onMount } from "svelte";
	import selectedMonth from "../../Methods/selectedMonth";
	import { Button, Modal } from "carbon-components-svelte";
	import Delete32 from "carbon-icons-svelte/lib/Delete32";

	// Custom Methods
	import {
		handleExpensesEdit,
		validateData,
	} from "../../methods/handleExpensesEdit.js";
	import deleteExpense from "../../methods/deleteExpense.js";

	// Stores
	import { ExpenseStore, BankStore, UserStore } from "../../store";

	const dispatch = createEventDispatcher();

	// Props
	export let open;
	export let recordId;
	export let recordIndex;
	export let recordDate;

	// Variables
	let uid;
	let expenseFormData = {
		expenseTitle: "",
		expenseCatagory: undefined,
		expenseAmount: undefined,
		selectedBank: undefined,
		expenseDate: undefined,
	};
	let validationProps = {
		titleEmpty: false,
		catagoryEmpty: false,
		amountEmpty: false,
		bankEmpty: false,
		dateEmpty: false,
	};

	// Stores
	let unsubExpenseStore;
	const unsubUserStore = UserStore.subscribe((data) => {
		uid = data.uid;
	});

	// Methods
	const callHandleExpenseEdit = () => {
		console.log("callHandleExpenseEdit");
		// validateData(expenseFormData)
		// 	.then((result) => {
		// 		if (result.validation) {
		// 			validationProps = {
		// 				titleEmpty: false,
		// 				catagoryEmpty: false,
		// 				amountEmpty: false,
		// 				bankEmpty: false,
		// 				dateEmpty: false,
		// 			};

		// 			handleExpensesEdit(
		// 				expenseFormData,
		// 				uid,
		// 				ExpenseStore,
		// 				BankStore
		// 			).then((response) => {
		// 				if (response.dataSaved) {
		// 					expenseFormData = {
		// 						expenseTitle: "",
		// 						expenseCatagory: undefined,
		// 						expenseAmount: undefined,
		// 						selectedBank: undefined,
		// 						expenseDate: undefined,
		// 					};
		// 				}
		// 			});
		// 		}
		// 	})
		// 	.catch((err) => {
		// 		validationProps = {
		// 			titleEmpty: false,
		// 			catagoryEmpty: false,
		// 			amountEmpty: false,
		// 			bankEmpty: false,
		// 			dateEmpty: false,
		// 		};
		// 		validationProps[`${err.field}`] = true;
		// 		console.log("err = ", err.msg);
		// 	});
	};

	const handleDeleteExpenseRecord = () => {
		deleteExpense(uid, recordId, recordIndex, recordDate);
	};

	// Life-cycle Methods

	afterUpdate(() => {
		unsubExpenseStore = ExpenseStore.subscribe((value) => {
			if (recordDate) {
				let recordData =
					value.data.history[new Date(recordDate).getFullYear()][
						selectedMonth(new Date(recordDate).getMonth())
					][new Date(recordDate).getDate()][recordIndex];
				expenseFormData = recordData;
			}
		});
	});

	onDestroy(() => {
		unsubExpenseStore();
		unsubUserStore();
	});
</script>

<Modal
	size="sm"
	bind:open
	modalHeading="Create database"
	primaryButtonText="Update Changes"
	secondaryButtonText="Cancel"
	on:click:button--secondary={() => dispatch('closeEditModal')}
	on:open
	on:close={() => dispatch('closeEditModal')}
	on:submit={callHandleExpenseEdit}>
	<div slot="heading" class="d-flex align-items-center">
		<h5 class="">Edit Expense</h5>

		<Button
			kind="danger"
			class="ml-3"
			icon={Delete32}
			hasIconOnly
			tooltipPosition="bottom"
			tooltipAlignment="center"
			iconDescription="Delete Expense"
			on:click={handleDeleteExpenseRecord} />
	</div>

	<!-- <div class="modal-content bg-light">
		<div class="modal-body">
			<form>
				<div class="form-row">
					<div class="form-group col-12 col-md">
						<label for="expenseTitle">Expense Title</label>
						<input
							type="text"
							class="form-control"
							class:is-invalid={validationProps.titleEmpty}
							id="expenseTitle"
							aria-describedby="emailHelp"
							placeholder="Enter Product, Investment or Person's name."
							bind:value={expenseFormData.expenseTitle} />
						<div
							class="invalid-feedback"
							class:d-none={!validationProps.titleEmpty}>
							Expense Title is Required
						</div>
					</div>

					<div class="form-group col-12 col-md">
						<label for="expenseCatagory">Expense Catagory/Type</label>
						<select
							class="custom-select"
							class:is-invalid={validationProps.catagoryEmpty}
							id="expenseCatagory"
							bind:value={expenseFormData.expenseCatagory}>
							<option value={undefined} selected>
								Select Expense Catagory/Type
							</option>
							<option value="Grocery">Grocery</option>
							<option value="Pets">Pets</option>
							<option value="Electrical Equipment">
								Electrical Equipments
							</option>
							<option value="Utility Bills">Utility Bills</option>
							<option value="Vegetables">Vegetables</option>
							<option value="Fruits">Fruits</option>
							<option value="Food">Food (Raw)</option>
							<option value="Food">Food (Cooked)</option>
							<option value="Snacks">Snacks</option>
							<option value="Construction Materials">
								Construction Materials
							</option>
							<option value="Home Accessories">Home Accessories</option>
							<option value="Kitchen Utensils">Kitchen Utensils</option>
							<option value="Home Maintenance">Home Maintenance</option>
							<option value="Medicine">Medicine</option>
							<option value="Telecom">Telecom</option>
							<option value="Tech/Gadgets">Tech/Gadgets</option>
							<option value="Others">Others</option>
						</select>
						<div
							class="invalid-feedback"
							class:d-none={!validationProps.titleEmpty}>
							Expense Title is Required
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="form-group col-12 col-md">
						<label for="expenseAmount">Expense Amount</label>
						<input
							type="number"
							class="form-control"
							class:is-invalid={validationProps.amountEmpty}
							id="expenseAmount"
							aria-describedby="Expense Amount"
							placeholder="Enter the amount."
							bind:value={expenseFormData.expenseAmount} />
						<div
							class="invalid-feedback"
							class:d-none={!validationProps.amountEmpty}>
							Expense Amount is Required
						</div>
					</div>

					<div class="form-group col-12 col-md">
						<label for="expenseCatagory">Banks</label>
						<div
							class="custom-control custom-radio"
							class:is-invalid={validationProps.bankEmpty}>
							<input
								type="radio"
								id="monthlyBank"
								name="bankRadio"
								class="custom-control-input"
								class:is-invalid={validationProps.bankEmpty}
								bind:group={expenseFormData.selectedBank}
								value="monthlyBank"
								required />
							<label
								class="custom-control-label"
								class:is-invalid={validationProps.bankEmpty}
								for="monthlyBank">Monthly Bank</label>
						</div>
						<div
							class="custom-control custom-radio"
							class:is-invalid={validationProps.bankEmpty}>
							<input
								type="radio"
								id="reserveBank"
								name="bankRadio"
								class="custom-control-input"
								class:is-invalid={validationProps.bankEmpty}
								bind:group={expenseFormData.selectedBank}
								value="reserveBank"
								required />
							<label
								class="custom-control-label"
								class:is-invalid={validationProps.bankEmpty}
								for="reserveBank">Reserve Bank</label>
						</div>
						<div
							class="invalid-feedback"
							class:d-none={!validationProps.bankEmpty}>
							Bank is Required
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="form-group col-6">
						<label for="expenseDate">Date</label>
						<input
							type="date"
							class="form-control"
							class:is-invalid={validationProps.dateEmpty}
							id="expenseDate"
							bind:value={expenseFormData.expenseDate} />
						<div
							class="invalid-feedback"
							class:d-none={!validationProps.dateEmpty}>
							Expense Date is Required
						</div>
					</div>
				</div>
			</form>
		</div>
	</div> -->
</Modal>
